import { Component, OnInit } from '@angular/core';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Action } from '../../../models/action';
import { selectJournalRecent } from '../../../store/journal/journal.state';
import { ActionStatusEnum } from '../../../enum/action-status.enum';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatLine } from '@angular/material/core';
import { AsyncPipe } from '@angular/common';
import { MatList, MatListItem } from '@angular/material/list';

@Component({
    selector: 'app-action-activity',
    templateUrl: './action-activity.component.html',
    styleUrls: ['./action-activity.component.scss'],
    imports: [MatList, MatListItem, MatLine, MatProgressBar, AsyncPipe]
})
export class ActionActivityComponent implements OnInit {

    actions$: Observable<Action[]>;

    constructor(private store: Store<AppState>) {
        this.actions$ = this.store.select(selectJournalRecent);
    }

    ngOnInit(): void {
    }

    processing(action: Action): boolean {
        return action.status === ActionStatusEnum.PROCESSING
    };

}
